<div baCardBlur class="animated fadeIn card {{cardType}} {{baCardClass || ''}}" zoom-in>
    <div *ngIf="cardTitle" class="card-header clearfix">
        <span class="card-title" translate>{{cardTitle}}</span>
    </div>
    <div class="card-body">
        <ng-content></ng-content>
    </div>
</div>
